module.exports = __webpack_public_path__ + "static/media/ConnectNow.48c5a4f3.png";